<template>
    <div class="ds-assignee-popover absolute z-10">
        <input v-if="list.length >= 5" v-model="search" class="ds-assignee-search" placeholder="Поиск" maxlength="100">
        <div class="ds-assignee-list">
        <div v-for="user in visibleUsers" :key="user.id" class="group ds-assignee-row relative" @click="select(user.id)" :class="{'ds-assignee-row-selected': user.id === selectedUser}">
            <User :last-name="user.last_name" :first-name="user.first_name" :avatar="user.avatar" :subtitle="user.position?.name" exchange />
            <Tooltip class="w-64 text-gray left-20">
                <div class="mb-1">{{ user.position.name }}</div>
                <div class="mb-1">{{ user.department.name }}</div>
                <div class="mb-1">{{ user.department.address }}</div>
            </Tooltip>
        </div>
        </div>
        <div class="ds-assignee-footer justify-between">
            <btn type="secondary" :disabled="isDisabled" :class="{'opacity-50': isDisabled}" @click="rejectUser">Отказать</btn>
            <btn class="ds-assignee-confirm" @click="assignUser" :disabled="isDisabled" :class="{'opacity-50': isDisabled}">Подтвердить</btn>
        </div>
    </div>
</template>

<script setup lang="ts">
    interface Props {
        vacancyId: string,
        list: Array<any>
    }

    import User from '../User.vue'
    import { ref, computed } from 'vue'
    import { useExchangeStore } from '@/stores/exchangeStore';
    import Tooltip from './Tooltip.vue';
    
    const { list, vacancyId } = defineProps<Props>()

    const store = useExchangeStore()

    const selectedUser = ref('')
    const search = ref('')
    const isDisabled = computed(() => !selectedUser.value)
    const visibleUsers = computed(() => {
        const value = search.value.trim().toLowerCase()
        if (!value) return list
        return list.filter(user => `${user.last_name} ${user.first_name} ${user.position?.name || ''}`.toLowerCase().includes(value))
    })

    const select = (id:string) => {
        selectedUser.value = id
    }

    const assignUser = async () => {
        await store.confirmVacancyAssignation(vacancyId, selectedUser.value)
    }

    const rejectUser = async () => {
        await store.rejectVacancyAssignation(vacancyId, selectedUser.value)
    }
  
</script>
